module.exports = __webpack_public_path__ + "img/case7-创维.a34391d1.png";